





















































































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import AsesmenRisikoJatuh from "@/services/AsesmenRisikoJatuh";
import { appModule } from "@/store/modules/app";
import { confirmRemove } from "@/utility/CommonHelper";
import FormAuthorization from "@/mixins/FormAuthorization";
import moment from "moment";
import storeRefAsesmen from "@/store/modules/new/ReferensiAsesmen";
import AsesmenRisikoJatuhInput from "@/components/AsesmenRisikoJatuhInput.vue";

@Component({
  components: {
    AsesmenRisikoJatuhInput
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class AsesmenRisikoJatuhPage extends Mixins(FormAuthorization) {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  headers = [
    { text: "Metode", value: "metode" },
    { text: "Skor", value: "skor" },
    { text: "Risiko", value: "risiko" },
    { text: "Unit", value: "unit.nama", sortable: false },
    { text: "Petugas", value: "petugas.nama", sortable: false },
    { text: "Waktu", value: "waktu_periksa" },
    { text: "Aksi", value: "id" }
  ];

  selectProps = { openOnHover: true, offsetY: true };

  tab = "tab-mfs";
  risjat: {
    id: number;
    metode: string;
    skor: number;
    question: any;
  } = null;

  sortBy = "waktu_periksa";
  sortDesc = true;
  loadingList = false;

  tug = null;
  hdVal = {};
  mfsVal = {};

  expanded = [];
  metode = "mfs";
  saving = false;
  risiko = 0;
  examinedAt: string | Date = new Date();

  timePickerProps = { format: "24hr", scrollable: true };
  datePickerProps = { locale: "id", max: moment().format("YYYY-MM-DD") };

  options = {
    page: 1,
    itemsPerPage: 5,
    sortBy: [this.sortBy],
    sortDesc: [this.sortDesc]
  };

  pagination = {
    total: 0,
    current_page: 1,
    per_page: 5,
    last_page: 1,
    from: 0,
    to: 0
  };

  get sessLogin() {
    return userModule.user;
  }

  // get parseRisjatList() {
  //   return this.risjatList.sort((a, b) => {
  //     return (
  //       new Date(b.waktu_periksa).getTime() -
  //       new Date(a.waktu_periksa).getTime()
  //     );
  //   });
  // }

  get totalMfs() {
    // return this.mfs.map(i => i.val).reduce((a, b) => a + b, 0);
    return Object.entries(this.mfsVal).length > 0
      ? Object.entries(this.mfsVal)
          .map(i => i[1]["scoring"])
          .reduce((a, b) => a + b, 0)
      : 0;
  }

  get interMfs() {
    return this.parseMfsRisiko(this.totalMfs);
  }

  parseMfsRisiko(skor) {
    this.risiko = 0;

    if (skor === null || skor === undefined) {
      return "";
    } else if (skor < 25) {
      return "Tidak Berisiko";
    } else if (skor < 51) {
      this.risiko = 1;
      return "Rendah";
    } else if (skor >= 51) {
      this.risiko = 1;
      return "Tinggi";
    }

    this.risiko = 0;
    return "";
  }

  parseMetodeText(str) {
    if (str === "mfs") {
      return "Morse Fall Score";
    }

    if (str === "hd") {
      return "Humpty Dumpty";
    }

    if (str === "tug") {
      return "Time Up and Go";
    }

    return "";
  }

  get intervensiMfs() {
    if (this.interMfs == "Tidak Berisiko") {
      return {
        id: 0,
        title: "Tidak Berisiko",
        color: "green",
        text: `
        1. Melakukan edukasi pada pasien dan keluarga <br/>
        2. Mengunci kursi roda/bet saat dihentikan <br/>
        3. Mengatur tempat tidur posisi terendah <br/>
        4. Pagar/pengaman samping tempat tidur dinaikkan <br/>
        5. Mendekatkan bel pada pasien agar mudah terjangkau <br/>
        6. Lakukan reessessment ulang setiap saat ada perubahan kondisi/program terapi
        `
      };
    } else if (this.interMfs == "Rendah") {
      return {
        id: 0,
        title: "Risiko Rendah",
        color: "orange",
        text: `
        1. Lakukan semua intervensi pada kategori tidak beresiko <br/>
        2. Memasang gelang tanda resiko jatuh <br/>
        3. Memasang segitiga risiko jatuh pada bed/kursi <br/>
        4. Lakukan assessment ulang setiap satu kali 24 jam
        `
      };
    } else if (this.interMfs == "Tinggi") {
      return {
        id: 0,
        title: "Risiko Tinggi",
        color: "red",
        text: `
        1. Lakukan semua tindakan pada kategori tidak berisiko dan risiko rendah <br/>
        2. Lakukan reassesment ulang 2 x setiap shift jaga
        `
      };
    } else {
      return null;
    }
  }

  get totalHd() {
    // return this.hd.map(i => i.val).reduce((a, b) => a + b, 0);
    return Object.entries(this.hdVal).length > 0
      ? Object.entries(this.hdVal)
          .map(i => i[1]["scoring"])
          .reduce((a, b) => a + b, 0)
      : 0;
  }

  get interHd() {
    return this.parseHdRisiko(this.totalHd);
  }

  parseHdRisiko(skor) {
    if (skor > 0 && skor < 12) {
      this.risiko = 1;
      return "Rendah";
    } else if (skor >= 12) {
      this.risiko = 1;
      return "Tinggi";
    }

    this.risiko = 0;
    return "";
  }

  get intervensiHd() {
    if (this.interHd == "Rendah") {
      return {
        id: 0,
        title: "Risiko Rendah",
        color: "orange",
        text: `
        1.Pengecekan bel mudah dijangkau <br/>
        2.Roda tempat tidur berada pada posisi terkunci <br/
        3.Posisi tempat tidur pada posisi terendah <br/
        4.Pagar pengaman tempat tidur dinaikkan <br/
        5.Asesmen dilakukan setiap 1 X 24 jam <br/
        6.Pasang tanda resiko jatuh gelang dan tanda segitiga resiko jatuh pada tempat tidur pasien <br/
        7.Edukasi dan melibatkan keluarga pasien dalam upaya pencegahan terjadinya jatuh
        `
      };
    } else if (this.interHd == "Tinggi") {
      return {
        id: 0,
        title: "Risiko Tinggi",
        color: "red",
        text: `
        1.Lakukan tindakan seperti pasien resiko rendah <br/>
        2.Bila memungkinkan pasien ditempatkan dekat nurse station <br/>
        3.Re-asemen pasien dilakukan 2 X setiap shif jaga <br/>
        `
      };
    } else {
      return null;
    }
  }

  get categoryMFS() {
    return storeRefAsesmen.fallriskMFS;
  }

  get categoryHD() {
    return storeRefAsesmen.fallriskHumDum;
  }

  parseTugRisiko(skor) {
    this.risiko = skor >= 1 ? 1 : 0;
    return skor >= 1 ? "Tinggi" : "Tidak berisiko";
  }

  mounted() {
    this.getByRegister();
  }

  @Watch("metode")
  changedMetode(val) {
    // this.tab = `tab-${val}`;
    if (val !== null) {
      this.createNewMfs();
    }
  }

  @Watch("options", { deep: true })
  changeOptions(val) {
    console.log("options change", val);
    this.getByRegister();
  }

  createNewMfs() {
    this.risjat = null;

    this.hdVal = {};
    this.mfsVal = {};

    this.tug = null;

    this.examinedAt = new Date();
  }

  clearForm() {
    this.metode = null;
    this.createNewMfs();
  }

  parseRisiko(item) {
    if (item.metode == "mfs") {
      return this.parseMfsRisiko(item.skor);
    }

    if (item.metode == "hd") {
      return this.parseHdRisiko(item.skor);
    }

    if (item.metode == "tug") {
      return this.parseTugRisiko(item.skor);
    }

    return "";
  }

  getRisikoClass(item) {
    let risk = "";

    if (item.metode == "mfs") {
      risk = this.parseMfsRisiko(item.skor);
    }

    if (item.metode == "hd") {
      risk = this.parseHdRisiko(item.skor);
    }

    if (item.metode == "tug") {
      risk = this.parseTugRisiko(item.skor);
    }

    if (risk.toLowerCase() === "rendah") {
      return "text-orange";
    }

    if (risk.toLowerCase() === "tinggi") {
      return "text-red";
    }

    return "";
  }

  edit(id) {
    const row = { ...this.risjatList.find(it => it.id == id) };

    if (this.validateUserEdit(row?.petugas.id)) {
      this.metode = row.metode;

      this.$nextTick(() => {
        // to make it deep copy immutable array or object use json.parse and json.stringify
        if (this.metode !== "tug") {
          const val: Array<any> = JSON.parse(JSON.stringify(row.question));
          const itm = {};

          val.forEach(it => {
            if (it.ref_group_id) {
              itm[it.ref_group_id] = this[
                `category${this.metode.toUpperCase()}`
              ]
                .find(cat => cat.id == it.ref_group_id)
                ?.val.find(val => val.id == it.ref_id);
            }
          });

          this[`${this.metode}Val`] = itm;
        } else {
          this.tug = row.skor;
        }
        this.risjat = JSON.parse(JSON.stringify(row));
        this.examinedAt = new Date(row.waktu_periksa);
      });
    }
  }

  remove(id) {
    const row = { ...this.risjatList.find(it => it.id == id) };

    if (
      this.validateUserEdit(row?.petugas.id) &&
      confirmRemove("Asesmen Risiko Jatuh")
    ) {
      const row = this.risjatList.find(it => it.id == id);

      row.deleting = true;

      AsesmenRisikoJatuh.destroy(id)
        .then(resp => {
          if (resp.status == 1) {
            appModule.NoticeDelay("Berhasil menghapus asesmen risiko jatuh");
          } else {
            alert(resp.message);
          }
        })
        .finally(() => {
          row.deleting = false;

          this.risjat = null;

          this.getByRegister();
        });
    }
  }

  expandRow(item) {
    // this.expanded.includes(item)
    //   ? this.expanded.splice(
    //       this.listRisjat.findIndex(list => list.lis_sampel == item.lis_sampel),
    //       1
    //     )
    //   : this.expanded.push(item);
  }

  risjatList = [];

  getByRegister() {
    this.loadingList = true;

    const { page, itemsPerPage, sortBy, sortDesc } = this.options;

    AsesmenRisikoJatuh.getByRegister(this.register, {
      page: page,
      per_page: itemsPerPage,
      sort_by: sortBy[0],
      sort_desc: sortDesc[0]
    })
      .then(resp => {
        if (resp.data) {
          this.risjatList = resp.data;

          this.pagination = {
            total: resp.total,
            current_page: resp.current_page,
            per_page: resp.per_page,
            last_page: resp.last_page,
            from: resp.from,
            to: resp.to
          };
        }
      })
      .finally(() => {
        this.loadingList = false;
      });
  }

  parseRowExpandableItem(
    item: Array<{
      risjat_id: number;
      ref_group_id: number;
      ref_id: string;
      skor: number;
    }>,
    metode: string
  ) {
    return item
      .map(it => {
        // return it.ref_group_id;
        if (it.ref_group_id) {
          return (
            this[`category${metode.toUpperCase()}`].find(
              cat => cat.id == it.ref_group_id
            ).title +
            ": " +
            this[`category${metode.toUpperCase()}`]
              .find(cat => cat.id == it.ref_group_id)
              ?.val.find(val => val.id == it.ref_id)?.title
          );
        }
      })
      .join("<br/>");
  }
}
